import type { ReactNode } from 'react';
import classnames from 'classnames';
import { Spinner } from 'react-bootstrap';
import * as styles from './Button.module.scss';

interface IButtonProps {
    children?: ReactNode;
    className?: string;
    disabled?: boolean;
    isButtonLink?: boolean;
    isLoading?: boolean;
    onClick?: () => void;
    submit?: boolean;
}

export function Button(props: IButtonProps) {
    const className = classnames('btn', props.className || '', styles.button, {
        [styles.buttonLink]: props.isButtonLink,
        [styles.isLoading]: props.isLoading,
    });

    return (
        <button
            className={className}
            disabled={props.disabled || props.isLoading}
            onClick={props.onClick}
            type={props.submit ? 'submit' : 'button'}
        >
            {props.children}
            {props.isLoading && (
                <span className="d-inline-flex ml-1">
                    <Spinner
                        animation="border"
                        as="span"
                        size="sm"
                    ></Spinner>
                </span>
            )}
        </button>
    );
}
